import { IcoDownloadAction, IcoUploadAction } from '@icons';
import React from 'react';

const UploadDownloadButton = ({
	variant = 'download',
	children,
	onClick,
	disabled = false,
}: {
	variant?: 'download' | 'upload';
	children: React.ReactNode;
	onClick: () => void;
	disabled?: boolean;
}) => {
	return (
		<button
			className="btn btn-primary d-flex align-items-center justify-content-between"
			style={{ width: 'fit-content', height: 'fit-content' }}
			onClick={(e) => {
				e.preventDefault();
				onClick();
			}}
			disabled={disabled}
		>
			{variant === 'download' ? (
				<IcoDownloadAction className={`ico-x-small download-upload white me-1 align-bottom p-0`} />
			) : (
				<IcoUploadAction className={`ico-x-small download-upload white me-1 align-bottom p-0`} />
			)}
			{children}
		</button>
	);
};

export default UploadDownloadButton;
